import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  cancel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  dangerZone: {
    id: 'studio.1fFBqQ',
    defaultMessage: 'Dangerous actions',
  },
  delete: {
    id: 'studio.ZMqEzX',
    defaultMessage: 'Delete app collection',
  },
  deleteWarningTitle: {
    id: 'studio.5IOAHQ',
    defaultMessage: 'Deleting app collection',
  },
  deleteWarning: {
    id: 'studio.e/r+2g',
    defaultMessage:
      'Are you sure you want to delete this app collection? This action cannot be reverted.',
  },
  deleteError: {
    id: 'studio.aajgdZ',
    defaultMessage: 'Something went wrong trying to delete this app collection',
  },
  deleteHelp: {
    id: 'studio.zo9Szm',
    defaultMessage: 'Deleting an app collection cannot be undone.',
  },
  deleteSuccess: {
    id: 'studio.Xr50rl',
    defaultMessage: 'Successfully deleted app collection {name}',
  },
  updateError: {
    id: 'studio.hJQLBM',
    defaultMessage: 'Something went wrong when trying to update the settings',
  },
  updateSuccess: {
    id: 'studio.0MC1vJ',
    defaultMessage: 'Successfully updated settings',
  },
  save: {
    id: 'studio.jvo0vs',
    defaultMessage: 'Save',
  },
});
